import { cloneDeep } from 'lodash';
import moment from 'moment';
import {
  panneauxLcUrlPhotoManager,
  panneauxNumeriqueUrlPhotoManager,
  reseauxUrlPhotoManager,
  reseauxPersonnaliseUrlPhotoManager,
} from '@/services/opportunite/opportuniteUrlPhotoManager';

function preInitializerReseauTempoPanier(reseauTempo) {
  if (!(reseauTempo.listeFaces && reseauTempo.listeFaces.length)) reseauTempo.listeFaces = [];
  const facesExtension = reseauTempo.extensionOpportunite.faces;
  if (facesExtension && facesExtension.length) {
    reseauTempo.listeFaces = cloneDeep(facesExtension);
  }
  reseauTempo.extensionOpportunite.faces = [];
}

function preInitializerPanneauxLcPanier(panneau) {
  if (!panneau.extensionOpportunite.dateDisponibilite) {
    panneau.extensionOpportunite.dateDisponibilite = new Date();
  } else {
    panneau.extensionOpportunite.dateDisponibilite =
      moment(panneau.extensionOpportunite.dateDisponibilite).toDate();
  }
  if (!panneau.extensionOpportunite.dateFin) {
    panneau.extensionOpportunite.dateFin = moment(panneau.extensionOpportunite.dateDisponibilite)
      .add(1, 'years').add(-1, 'days').toDate();
  } else {
    panneau.extensionOpportunite.dateFin =
      moment(panneau.extensionOpportunite.dateFin).toDate();
  }
}

export default function preInitializerOpportunitePanier(opp) {
  opp.data.produits.reseauxTempo.forEach(res => {
    preInitializerReseauTempoPanier(res);
    reseauxUrlPhotoManager(res, true);
  });
  opp.data.produits.panneauxLc.forEach(panneau => {
    preInitializerPanneauxLcPanier(panneau);
    panneauxLcUrlPhotoManager(panneau, true);
  });
  opp.data.produits.panneauxNumeriques.forEach(panneau => {
    panneauxNumeriqueUrlPhotoManager(panneau, true);
  });
  opp.data.produits.reseauxLc.forEach(res => {
    reseauxUrlPhotoManager(res, true);
  });
  opp.data.produits.reseauxNumeriques.forEach(res => {
    reseauxUrlPhotoManager(res, true);
  });
  opp.data.produits.reseauxPersonnalise.forEach(res => {
    reseauxPersonnaliseUrlPhotoManager(res, true);
  });
}



// WEBPACK FOOTER //
// ./src/services/panier/preInitializerOpportunitePanier.js